import { Subject } from 'rxjs';

export interface ButtonActionEvent {}

export type ButtonActionSubject = Subject<ButtonActionEvent>;

/**
 * Crea il Subject (RxJS) che viene utilizzato per comunicare l'evento di
 * click di un widget Button.
 */
export function createButtonActionSubject() {
  return new Subject<ButtonActionEvent>();
}
